module.exports = __webpack_public_path__ + "img/status-ready.27b23978.svg";